import makeStyles from '@mui/styles/makeStyles';

const useAddExternalUserspageStyles = makeStyles({
  root: {}
});

export default useAddExternalUserspageStyles;
